import { useTranslation } from 'react-i18next';
import styles from './GoodInvalidRenderer.module.scss';
import { VdsIcon, VdsTooltip } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';
import { EmptyCell } from '../../formatters/genericFormatters';

export interface GoodInvalidRendererProps {
  value?: boolean;
  endFixValid?: boolean;
}

export function GoodInvalidRenderer({
  value,
  endFixValid,
}: GoodInvalidRendererProps): ReactElement | string {
  const { t } = useTranslation();

  if (value !== undefined) {
    const text = value ? t('Good') : t('Invalid');

    return endFixValid === false ? (
      <div className={styles.withTooltip}>
        {text}
        <VdsTooltip
          id="sidepanel-duration-error"
          event="hover"
          max-width="250px"
          position="right"
          type="standard"
          text={t('EndFixInvalidCalcQualityPoor')}
        >
          <VdsIcon slot="tooltip-trigger" color="grey-500" svgIcon="information" size="20px" />
        </VdsTooltip>
      </div>
    ) : (
      text
    );
  }

  return EmptyCell;
}

export default GoodInvalidRenderer;
